import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/dealers');
}
//Get all active 
export function allActive(){
    return http().get('/dealers/active');
}

//Get List for table view with - Pagination 
export function listPage(obj){
    let params = {
        page:obj.page, 
        recordsPerPage:obj.recordsPerPage, 
        q:obj.q, 
        selectedStatus:obj.selectedStatus, 
        sort_direction:obj.sort_direction, 
        sort_field:obj.sort_field
    }
    return http().get(`/dealers/list-page`, {
        params:params
    });
}


// Get all active for dropdown
export function dropdown(){
    return http().get('/dealers/dropdown');
}
// Get all active dealer which belongs to dealer manager into dropdown
export function whichBelongsToDealerManagersDropdown(dealerManagerId){
    return http().get(`/dealers/which-belongs-to-dealer-managers/dropdown/${dealerManagerId}`);
}
// Get all active for dealer staff into dropdown
export function staffDropdown(dealerId){
    return http().get(`/dealers/staff/dropdown/${dealerId}`);
}

// Get all dealers which belongs to user
export function dealersBelongsToUserDropdown(userId){
    return http().get(`/dealers/dealers-belongs-to-user/dropdown/${userId}`);
}

//Get Single
export function single(id){
    return http().get(`/dealers/${id}`);
}
//Add one
export function add(data){
    return http().post('/dealers', data)
}
//Update
export function update(id, data){
    return http().put(`/dealers/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/dealers/${id}`);
}